import { Grid } from '@material-ui/core'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { GridItem } from '../../../../shared/grid-item'
import { useMainPageSustainabilitySectionStyles } from './main-page-sustainability-section.styles'

function sustainabilityImageSrc(): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '')
  return `${base}/images/sustainability/section.jpg`
}

export const MainPageSustainabilitySection: React.FC = () => {
  const classes = useMainPageSustainabilitySectionStyles()
  const { t, i18n } = useTranslation()

  const points = useMemo((): string[] => {
    const raw = t('mainPage.sustainability.points', { returnObjects: true })
    return Array.isArray(raw) ? (raw as string[]) : []
  }, [t, i18n.language])

  const imageAlt = t('mainPage.sustainability.imageAlt')

  return (
    <section
      className={classes.root}
      aria-labelledby="sustainability-heading"
    >
      <div className={classes.inner}>
        <Grid container spacing={5} alignItems="center">
          <GridItem xs={12} md={6}>
            <div className={classes.imageFrame}>
              <img
                className={classes.image}
                src={sustainabilityImageSrc()}
                alt={imageAlt}
                width={960}
                height={720}
                loading="lazy"
                decoding="async"
              />
            </div>
          </GridItem>
          <GridItem xs={12} md={6}>
            <h2 className={classes.title} id="sustainability-heading">
              {t('mainPage.sustainability.title')}
            </h2>
            <p className={classes.lead}>{t('mainPage.sustainability.lead')}</p>
            {points.length > 0 && (
              <ul className={classes.list}>
                {points.map((line, idx) => (
                  <li key={idx} className={classes.listItem}>
                    {line}
                  </li>
                ))}
              </ul>
            )}
          </GridItem>
        </Grid>
      </div>
    </section>
  )
}
